import lang from '@/lang'
import { isMeinBuero } from '@/utils/build-env'

const ACTION_PREFIX = 'onboarding/main'
const SET_COUNTRY_ISO = `${ACTION_PREFIX}/SET_COUNTRY_ISO`
const SET_USE_VAT = `${ACTION_PREFIX}/SET_USE_VAT`
const SET_PASSWORD_DATA = `${ACTION_PREFIX}/SET_PASSWORD_DATA`
const SET_COMPANY_DATA = `${ACTION_PREFIX}/SET_COMPANY_DATA`
const SWITCH_AVV_STATE = `${ACTION_PREFIX}/SWITCH_AVV_STATE`
const SWITCH_AGB_STATE = `${ACTION_PREFIX}/SWITCH_AGB_STATE`
const SET_COMPANY_SIZE = `${ACTION_PREFIX}/SET_COMPANY_SIZE`
const SET_YEAR_OF_CREATION = `${ACTION_PREFIX}/SET_YEAR_OF_CREATION`
const SET_REGISTRATION_DATA = `${ACTION_PREFIX}/SET_REGISTRATION_DATA`
const SET_IS_SMALLBUSINESS = `${ACTION_PREFIX}/SET_IS_SMALLBUSINESS`
const SET_IS_SUBJECT_TO_IMPUTED_TAXATION = `${ACTION_PREFIX}/SET_IS_SUBJECT_TO_IMPUTED_TAXATION`
const SET_INDUSTRY = `${ACTION_PREFIX}/SET_INDUSTRY`
const SET_USER_EXPERIENCE_TEXTS = `${ACTION_PREFIX}/SET_USER_EXPERIENCE_TEXTS`
const SET_DEMO_TENANT = `${ACTION_PREFIX}/SET_DEMO_TENANT`
const SET_TOKEN = `${ACTION_PREFIX}/SET_TOKEN`
const SET_AVV_ALREADY_CONFIRMED = `${ACTION_PREFIX}/SET_AVV_ALREADY_CONFIRMED`
const SET_LOGO = `${ACTION_PREFIX}/SET_LOGO`
const SET_IS_SAVING = `${ACTION_PREFIX}/SET_IS_SAVING`
const RESET_STATE = `${ACTION_PREFIX}/RESET_STATE`
const SET_SUBSCRIPTION_TYPE = `${ACTION_PREFIX}/SET_SUBSCRIPTION_TYPE`

const initialState = {
  passwordData: {
    password: '',
    repeatPassword: '',
  },
  avvAlreadyConfirmed: false,
  token: '',
  registrationData: {
    email: '',
    password: '',
    newsletter: true,
  },
  useVat: null,
  onboardingStep: 'start',
  acceptAvv: false,
  acceptAgb: false,
  isSubjectToImputedTaxation: !isMeinBuero(),
  isSmallBusiness: false,
  startWithDemoTenant: null,
  companyData: {
    companyName: '',
    street: '',
    zipCode: '',
    city: '',
    firstName: '',
    lastName: '',
    phone1: '',
    countryIso: 'DE',
    source: '',
  },
  isSaving: false,
  industry: { name: '', group: '' },
  experience: '',
  subscriptionTypeTypes: null,
}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case SET_COUNTRY_ISO: {
      const { countryIso } = action
      return { ...state, countryIso }
    }
    case SET_USE_VAT: {
      const { useVat } = action
      return { ...state, useVat }
    }
    case SET_PASSWORD_DATA: {
      const { passwordData } = action
      return { ...state, passwordData: { ...state.passwordData, ...passwordData } }
    }
    case SET_COMPANY_DATA: {
      const { companyData } = action
      return { ...state, companyData: { ...state.companyData, ...companyData } }
    }
    case SWITCH_AVV_STATE: {
      return { ...state, acceptAvv: !state.acceptAvv }
    }
    case SWITCH_AGB_STATE: {
      return { ...state, acceptAgb: !state.acceptAgb }
    }
    case SET_COMPANY_SIZE: {
      const { companySize } = action
      return { ...state, companySize }
    }
    case SET_REGISTRATION_DATA: {
      const { registrationData } = action
      return { ...state, registrationData: { ...state.registrationData, ...registrationData } }
    }
    case SET_IS_SMALLBUSINESS: {
      const { isSmallBusiness } = action
      return { ...state, isSmallBusiness, useVat: !isSmallBusiness }
    }
    case SET_IS_SUBJECT_TO_IMPUTED_TAXATION: {
      const { isSubjectToImputedTaxation } = action
      return { ...state, isSubjectToImputedTaxation, useVat: null, isSmallBusiness: false }
    }
    case SET_INDUSTRY: {
      const { industry } = action
      return { ...state, industry: { ...state.industry, ...industry } }
    }
    case SET_USER_EXPERIENCE_TEXTS: {
      const { experience } = action
      return { ...state, experience }
    }
    case SET_DEMO_TENANT: {
      const { startWithDemoTenant } = action
      return { ...state, startWithDemoTenant }
    }
    case SET_TOKEN: {
      const { token } = action
      return { ...state, token }
    }
    case SET_AVV_ALREADY_CONFIRMED: {
      const { avvAlreadyConfirmed } = action
      return { ...state, avvAlreadyConfirmed }
    }
    case SET_LOGO: {
      const { logo } = action
      return { ...state, logo: { ...state.logo, ...logo } }
    }
    case SET_IS_SAVING: {
      const { isSaving } = action
      return { ...state, isSaving }
    }
    case RESET_STATE: {
      return initialState
    }
    case SET_SUBSCRIPTION_TYPE: {
      const { subscriptionTypeTypes } = action
      return { ...state, subscriptionTypeTypes }
    }
    default: {
      return state
    }
  }
}

export const setCountryIso = (countryIso) => ({ type: SET_COUNTRY_ISO, countryIso })
export const setUseVat = (useVat) => ({ type: SET_USE_VAT, useVat })
export const setPasswordData = (passwordData) => ({ type: SET_PASSWORD_DATA, passwordData })
export const setCompanyData = (companyData) => ({ type: SET_COMPANY_DATA, companyData })
export const switchAgbState = () => ({ type: SWITCH_AGB_STATE })
export const switchAvvState = () => ({ type: SWITCH_AVV_STATE })
export const setCompanySize = (companySize) => ({ type: SET_COMPANY_SIZE, companySize })
export const setYearOfCreation = (yearOfCreation) => ({ type: SET_YEAR_OF_CREATION, yearOfCreation })
export const setRegistrationData = (registrationData) => ({ type: SET_REGISTRATION_DATA, registrationData })
export const setSmallBusiness = (isSmallBusiness) => ({ type: SET_IS_SMALLBUSINESS, isSmallBusiness })
export const setSubjectToImputedTaxation = (isSubjectToImputedTaxation) => ({ type: SET_IS_SUBJECT_TO_IMPUTED_TAXATION, isSubjectToImputedTaxation })
export const setIndustry = (industry) => ({ type: SET_INDUSTRY, industry })
export const setUserExperienceTexts = (experience) => ({ type: SET_USER_EXPERIENCE_TEXTS, experience })
export const setStartWithDemoTenant = (startWithDemoTenant) => ({ type: SET_DEMO_TENANT, startWithDemoTenant })
export const setToken = (token) => ({ type: SET_TOKEN, token })
export const setAvvAlreadyConfirmed = (avvAlreadyConfirmed) => ({ type: SET_AVV_ALREADY_CONFIRMED, avvAlreadyConfirmed })
export const setLogo = logo => ({ type: SET_LOGO, logo })
export const setIsSaving = (isSaving) => ({ type: SET_IS_SAVING, isSaving })
export const resetState = () => ({ type: RESET_STATE })
export const setSubscriptionTypes = (subscriptionTypeTypes) => ({ type: SET_SUBSCRIPTION_TYPE, subscriptionTypeTypes })
